/**
 * OC Chat Footer Component
 * Footer with optional disclaimer text
 * Only displays after user has sent their first message (not in initial state)
 */

import React from 'react';

import { useOcFabWidgetOptions } from '../../contexts/OcFabWidgetOptionsContext';
import { FooterContainer, FooterContent, FooterText } from './OcChatFooter.styled';

/**
 * OcChatFooter Component
 * Displays footer with optional text inside the input area
 * Shown after initial state (matching behavior of ReactRoot widget)
 */
export const OcChatFooter: React.FC = () => {
  const { footerText } = useOcFabWidgetOptions();

  if (!footerText) {
    return null;
  }

  return (
    <FooterContainer>
      <FooterContent>
        <FooterText>{footerText}</FooterText>
      </FooterContent>
    </FooterContainer>
  );
};

export default OcChatFooter;
